/**
 * Admin i18n dictionary types — nested string trees.
 * Domains may add arbitrary namespaces (products, orders, …).
 */
export type DictValue = string | { [key: string]: DictValue }
export type Dictionary = { [key: string]: DictValue }

/** Deep-merge overlay onto base (overlay wins on leaf strings). */
export function mergeDictionaries(...parts: Dictionary[]): Dictionary {
  let out: Dictionary = {}
  for (const part of parts) {
    out = mergeOne(out, part) as Dictionary
  }
  return out
}

function mergeOne(base: DictValue, overlay: DictValue): DictValue {
  if (typeof overlay === 'string') return overlay
  if (typeof base === 'string' || base == null) return overlay
  if (!overlay || typeof overlay !== 'object') return base
  const out: { [key: string]: DictValue } = { ...(base as object) }
  for (const [k, v] of Object.entries(overlay)) {
    if (v == null) continue
    const prev = out[k]
    out[k] =
      typeof v === 'string' || typeof prev === 'string' || prev == null
        ? v
        : mergeOne(prev, v)
  }
  return out
}
